/**
 * Mekke プロフィールフック
 * 共通フックを使用し、stats（スポット/冊子数）を追加
 */
import { useQuery } from "@tanstack/react-query";
import { useAtom } from "jotai";
import { useProfileCore, profileKeys } from "@tabipla/hooks/profile";
import { userAtom } from "../atoms/auth-atoms";
import { apiClient } from "@/infrastructure/api/client";

// Re-export query keys for direct access if needed
export { profileKeys };

interface ProfileStatsDto {
  spotCount: number;
  bookletCount: number;
}

export function useProfile() {
  const [user, setUser] = useAtom(userAtom);

  const core = useProfileCore({
    apiClient,
    getUserId: () => user?.id ?? null,
    getUser: () => user,
    setUser,
  });

  // Mekke固有: プロフィール統計（スポット数、冊子数）
  const stats = useQuery({
    queryKey: ["profileStats"],
    queryFn: async () => {
      // Get spots count
      const spotsResponse = await apiClient.get<{ id: string }[]>("/api/mekke/spots");
      const spotCount = spotsResponse.success ? (spotsResponse.data?.length ?? 0) : 0;

      // Get booklets count
      const bookletsResponse = await apiClient.get<{ id: string }[]>("/api/mekke/booklets");
      const bookletCount = bookletsResponse.success ? (bookletsResponse.data?.length ?? 0) : 0;

      return { spotCount, bookletCount } as ProfileStatsDto;
    },
    enabled: !!user,
  });

  return {
    user,
    stats,
    ...core,
  };
}
